import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';
import { AnnotationModel } from '@/engine/app/modules/indications/annotation/Annotation.model';
import { TYPES } from '@/engine/ioc';
import { inject, injectable } from 'inversify';

@injectable()
export class AnnotationTwoDController {
  private _planningAlgorithm: PlanningAlgorithm;

  public constructor(@inject(TYPES.PlanningAlgorithm) planningAlgorithm: PlanningAlgorithm) {
    this._planningAlgorithm = planningAlgorithm;
  }

  public setText(annotationDescriptor: string, text: string): void {
    const annotationModel = this._planningAlgorithm.getValueStrict(annotationDescriptor, AnnotationModel);
    annotationModel.setText(text);
  }
}
